// Servicio para manejar operaciones de patrocinios con la base de datos
import { environment } from '../config/environment';
import { getApiHeaders, getApiHeadersForGet } from '../utils/apiUtils';

class SponsorshipService {
  constructor() {
    this.baseUrl = environment.apiBaseUrl; // URL del servidor backend (configurado según entorno)
  }

  // Crear un nuevo patrocinio
  async createSponsorship(sponsorshipData) {
    try {
      const response = await fetch(`${this.baseUrl}/sponsorships`, {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify(sponsorshipData)
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error creating sponsorship:', error);
      throw error;
    }
  }

  // Obtener todos los patrocinios
  async getAllSponsorships() {
    try {
      const response = await fetch(`${this.baseUrl}/sponsorships`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const sponsorships = await response.json();
      return sponsorships;
    } catch (error) {
      console.error('Error fetching sponsorships:', error);
      throw error;
    }
  }

  // Obtener patrocinios por concurso
  async getSponsorshipsByContest(contestId) {
    try {
      const response = await fetch(`${this.baseUrl}/sponsorships/contest/${contestId}`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const sponsorships = await response.json();
      return sponsorships;
    } catch (error) {
      console.error('Error fetching sponsorships by contest:', error);
      throw error;
    }
  }

  // Obtener un patrocinio por ID
  async getSponsorshipById(id) {
    try {
      const response = await fetch(`${this.baseUrl}/sponsorships/${id}`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const sponsorship = await response.json();
      return sponsorship;
    } catch (error) {
      console.error('Error fetching sponsorship:', error);
      throw error;
    }
  }

  // Actualizar un patrocinio
  async updateSponsorship(id, sponsorshipData) {
    try {
      const response = await fetch(`${this.baseUrl}/sponsorships/${id}`, {
        method: 'PUT',
        headers: getApiHeaders(),
        body: JSON.stringify(sponsorshipData)
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error updating sponsorship:', error);
      throw error;
    }
  }

  // Eliminar un patrocinio
  async deleteSponsorship(id) {
    try {
      const response = await fetch(`${this.baseUrl}/sponsorships/${id}`, {
        method: 'DELETE',
        headers: getApiHeaders()
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error deleting sponsorship:', error);
      throw error;
    }
  }
}

export default new SponsorshipService();
